<template>
  <div>
    <v-form ref="form">
      <v-row>
        <v-autocomplete
          v-model="selectedForteItem"
          :items="forteItemsWithStatus"
          :rules="reqdSelectValidation"
          item-text="label"
          item-value="name"
          label="Select Forte Import"
          outlined
        >
          <template v-slot:item="{ item }">
            <div class="forte-item-row d-flex align-center justify-space-between" style="width: 100%;">
              <span>
                <v-icon
                  v-if="item.imported"
                  color="success"
                  small
                  class="mr-2"
                >mdi-check-circle</v-icon>
                <span :class="{ 'font-weight-medium success--text': item.imported || item.noData }">
                  {{ item.label }}<span v-if="item.noData" class="ml-1 success--text"> - no data to import</span>
                </span>
              </span>
              <span v-if="item.hasSummary">
                <v-icon
                  small
                  class="ml-2"
                  title="Print summary"
                  @click.stop="printSummary(item.name)"
                >mdi-printer</v-icon>
                <v-icon
                  small
                  class="ml-2"
                  title="Re-send summary email"
                  @click.stop="resendSummaryEmail(item.name)"
                >mdi-email-send-outline</v-icon>
              </span>
            </div>
          </template>
          <template v-slot:selection="{ item }">
            <v-icon v-if="item.imported" color="success" small class="mr-1">mdi-check-circle</v-icon>
            <span :class="{ 'success--text': item.noData }">{{ item.label }}<span v-if="item.noData"> - no data to import</span></span>
          </template>
        </v-autocomplete>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-0 pb-0 ma-0">
          <ClarionDateControl
            class="input-text-size"
            label="Business Date"
            v-model="bussinessDate"
            :isToggle=false
            :rules="reqdSelectValidation"
          />
        </v-col>
        <v-col cols="4" class="pt-0 pb-0 ma-0">
          <v-select
            class="input-text-size"
            label="WKST"
            :items="paymentWkstNumList"
            v-model="selectedWkstItem"
            :rules="reqdSelectValidation"
          />
        </v-col>
      </v-row>
    </v-form>
    <!-- <v-row>
      <table>
        <tbody>
          <div style="color: red;" v-for="item in misMatchItemsList" :key="item.res">
            <tr><td> Payment#: {{ item.res }}</td></tr>
          </div>
        </tbody>
      </table>
    </v-row> -->
    <v-dialog v-model="showResultsDialog" max-width="800">
      <v-card >
        <v-card-title class="headline">
          <!-- {{ importResponse.data.message }} -->
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <div class="text-subtitle-1">
                Records Imported: {{ (misMatchItemsList.importRecords || []).length }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-1">
                Records Skipped: {{ (misMatchItemsList.skippedRecords || []).length }}
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <div>
            <div class="text-h6 mb-2">Skipped Records:</div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Tax ID</th>
                    <th>Tax Year</th>
                    <th>Tax Amount</th>
                    <th>Penalty</th>
                    <th>Fee</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, index) in misMatchItemsList.skippedRecords" :key="index">
                    <td>{{ record.taxId }}</td>
                    <td>{{ record.taxYear }}</td>
                    <td>{{ record.taxAmt }}</td>
                    <td>{{ record.taxPenalty }}</td>
                    <td>{{ record.taxFeeTotal }}</td>
                    <td>{{ record.reason }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showResultsDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-btn @click="importForteData">Import</v-btn>
    </v-row>
    <v-overlay :value="overlay">
     <v-progress-circular
       :size="50"
       color="primary"
       indeterminate
     ></v-progress-circular>
   </v-overlay>
  </div>
</template>

<script>
import {
  mapActions, mapState, mapGetters,
  mapMutations,
} from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import { clients } from '../../../../../util/clients';
import { generateQueryString } from '../../../../common/base/report/report-util';

const { backendRest } = clients.direct;

export default {
  components: {
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
    },
  },
  data() {
    return {
      forteItems: [],
      importedFileNames: [],
      noDataFileNames: [],
      summaryFileNames: [],
      selectedForteItem: null,
      overlay: false,
      bussinessDate: null,
      selectedWkstItem: null,
      showResultsDialog: false,
    };
  },
  mounted() {
    this.fetchForteItems();
    this.setDefaultData();
  },
  computed: {
    ...mapState({
      paymentWkstNumList: (state) => state.tax.taxPayment.paymentWkstNumList || [],
      misMatchItemsList: (state) => state.tax.taxPayment.misMatchItemsList || [],
    }),
    ...mapGetters('base/crud', ['criteria']),
    criteriaState() {
      return this.criteria(this.baseCrudKey);
    },
    forteItemsWithStatus() {
      return this.forteItems.map((item) => ({
        ...item,
        imported: this.importedFileNames.includes(item.name),
        noData: this.noDataFileNames.includes(item.name),
        hasSummary: this.summaryFileNames.includes(item.name),
      }));
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
  },
  methods: {
    ...mapActions(['reAuth', 'flashError', 'flashWarn', 'flashSuccess']),
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapMutations('tax/taxPayment', [
      'setMisMatchItemsList',
    ]),
    async wkstTaxsetting() {
      const taxConfig = await this.loadConfig({ requiredScope: 'taxConfig' });
      return (taxConfig && taxConfig[0]) || [];
    },
    async setDefaultData() {
      // console.info('--this.baseCrudKey---', this.baseCrudKey);
      // console.info('--this.criteriaState---', this.criteriaState);
      const wkstTaxSetting = await this.wkstTaxsetting();
      const wkst = wkstTaxSetting.configuration.webPaymentNo !== ''
        ? Number(wkstTaxSetting.configuration.webPaymentNo)
        : this.criteriaState.criteriaWkst[0];
      this.bussinessDate = this.criteriaState.postingPayDate || null; // Set default business date
      this.selectedWkstItem = wkst || null; // Set default WKST
    },
    async fetchForteItems() {
      try {
        this.overlay = true;
        const { jwt } = await this.reAuth();
        const params = [
          `token=${jwt}`,
        ];
        const queryString = generateQueryString(params);
        const [listResponse, importedResponse] = await Promise.all([
          backendRest.get(`/tax/ccPayments/forte/list${queryString}`),
          backendRest.get(`/tax/ccPayments/forte/imported-files${queryString}`),
        ]);
        this.forteItems = listResponse.data;
        const importedRecords = importedResponse.data || [];
        this.importedFileNames = importedRecords.filter((f) => !f.noData).map((f) => f.fileName || f);
        this.noDataFileNames = importedRecords.filter((f) => f.noData).map((f) => f.fileName || f);
        this.summaryFileNames = importedRecords.filter((f) => f.hasSummary).map((f) => f.fileName || f);
      } catch (error) {
        console.error('Error fetching Forte items:', error);
      } finally {
        this.overlay = false;
      }
    },
    async refreshImportedFiles() {
      try {
        const { jwt } = await this.reAuth();
        const params = [`token=${jwt}`];
        const queryString = generateQueryString(params);
        const response = await backendRest.get(`/tax/ccPayments/forte/imported-files${queryString}`);
        const refreshedRecords = response.data || [];
        this.importedFileNames = refreshedRecords.filter((f) => !f.noData).map((f) => f.fileName || f);
        this.noDataFileNames = refreshedRecords.filter((f) => f.noData).map((f) => f.fileName || f);
        this.summaryFileNames = refreshedRecords.filter((f) => f.hasSummary).map((f) => f.fileName || f);
      } catch (error) {
        console.error('Error refreshing imported files:', error);
      }
    },
    async printSummary(fileName) {
      try {
        const { jwt } = await this.reAuth();
        const params = [`token=${jwt}`, `fileName=${fileName}`];
        const queryString = generateQueryString(params);
        const pdfResponse = await backendRest.get(
          `/tax/ccPayments/forte/imported-files/summary${queryString}`,
          { responseType: 'blob' },
        );
        const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        const summaryWindow = window.open(blobUrl, '_blank');
        if (!summaryWindow) {
          this.flashWarn('Pop-up blocked - allow pop-ups for this site to view the summary.');
        }
      } catch (error) {
        console.error('Error printing summary:', error);
        if (error && error.response && error.response.status === 404) {
          this.flashError('No stored summary found for this file.');
        } else {
          this.flashError('Failed to print the summary.');
        }
      }
    },
    async resendSummaryEmail(fileName) {
      try {
        const { jwt } = await this.reAuth();
        const params = [`token=${jwt}`, `fileName=${fileName}`];
        const queryString = generateQueryString(params);
        const response = await backendRest.get(`/tax/ccPayments/forte/imported-files/resend-email${queryString}`);
        if (response && response.data && response.data.emailResult && response.data.emailResult.status) {
          this.flashSuccess('Summary email re-sent.');
        } else {
          this.flashWarn('Summary email could not be sent - check recipients/mail configuration.');
        }
      } catch (error) {
        console.error('Error resending summary email:', error);
        if (error && error.response && error.response.status === 404) {
          this.flashError('No stored summary found for this file.');
        } else {
          this.flashError('Failed to re-send the summary email.');
        }
      }
    },
    async importForteData() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (window.confirm(`Are you sure you want to import ${this.selectedForteItem} data?`)) {
        this.overlay = true;
        try {
          await this.performImport();
        } catch (error) {
          console.error('Error during import:', error);
          this.flashError('Error during import.');
        } finally {
          this.overlay = false;
        }
      }
    },
    async performImport() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
        `fileName=${this.selectedForteItem}`,
      ];
      const queryString = generateQueryString(params);
      const importResponse = await backendRest.get(`/tax/ccPayments/forte/import${queryString}`);
      const { chunkID } = importResponse.data;

      if (chunkID) {
        const integrationParams = [
          `token=${jwt}`,
          `chunkID=${chunkID}`,
          `businessDate=${this.bussinessDate}`,
          `workstation=${this.selectedWkstItem}`,
          `fileName=${this.selectedForteItem}`,
        ];
        const integrationQueryString = generateQueryString(integrationParams);
        const records = await backendRest.get(`/tax/ccPayments/forte/integration${integrationQueryString}`);
        if (records && records.data) {
          this.setMisMatchItemsList(records.data);
          const summaryCriteria = {
            recordsImportedCount: (this.misMatchItemsList.importRecords || []).length,
            recordsSkippedCount: (this.misMatchItemsList.skippedRecords || []).length,
            importedRecords: this.misMatchItemsList.importRecords || [],
            skippedRecords: this.misMatchItemsList.skippedRecords || [],
            posRecords: this.misMatchItemsList.posRecords || [],
            reversedRecords: this.misMatchItemsList.reversedRecords || [],
            batchDate: this.selectedForteItem,
          };
          const pdfResponse = await backendRest.post(
            '/tax/ccPayments/forte/web-import-summary',
            summaryCriteria,
            { responseType: 'blob' }, // Ensure response is treated as binary
          );
            // Open the PDF in a new browser tab
          const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
          const blobUrl = window.URL.createObjectURL(blob);
          const summaryWindow = window.open(blobUrl, '_blank');
          this.showResultsDialog = true;
          if (summaryWindow) {
            this.flashSuccess('Forte data imported and integrated successfully.');
          } else {
            this.flashWarn('Pop-up blocked - the import succeeded but the summary PDF could not open. Allow pop-ups for this site and reload the file to view the summary.');
          }
          this.refreshImportedFiles();
          this.$emit('searchByCriteria');
        }
      } else {
        this.flashWarn('Forte data imported successfully, but no chunkID received for integration.');
      }
    },
  },
};
</script>

<style scoped>
.forte-item-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 0;
}
</style>
